import React from 'react';
import { useTranslation } from 'react-i18next';

const verdictColors = {
  legitimate: '#00d4aa',
  caution: '#ffa502',
  suspicious: '#ff6348',
  scam: '#ff4757',
};

const defaultVerdict = 'legitimate';

export default function ScoreRing({ score, verdict, size: sizeProp, compact = false }) {
  const { t } = useTranslation();

  const defaultSize = compact ? 100 : 160;
  const size = sizeProp ?? defaultSize;

  const radius = (size - 16) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (score / 100) * circumference;

  const effectiveVerdict = verdictColors[verdict] ? verdict : defaultVerdict;
  const color = verdictColors[effectiveVerdict];
  const label = t('score.' + effectiveVerdict);
  const adviceKey = 'score.advice' + effectiveVerdict.charAt(0).toUpperCase() + effectiveVerdict.slice(1);
  const action = t(adviceKey);

  const scoreFontSize = compact ? 'text-2xl' : 'text-4xl sm:text-4xl';
  const subFontSize = compact ? 'text-[10px]' : 'text-xs';

  return (
    <div className="inline-flex flex-col items-center gap-2">
      <div
        className="relative inline-flex items-center justify-center"
        style={{ width: size, height: size }}
      >
        <svg
          width={size}
          height={size}
          className="-rotate-90"
          role="img"
          aria-label={`Score de risque : ${score} sur 100, niveau ${label}`}
        >
          <circle
            cx={size / 2} cy={size / 2} r={radius}
            fill="none" stroke="#334155" strokeWidth="8"
          />
          <circle
            cx={size / 2} cy={size / 2} r={radius}
            fill="none" stroke={color} strokeWidth="8"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            className="transition-all duration-1000 ease-out"
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className={`${scoreFontSize} font-bold text-white font-mono`}>{score}</span>
          <span className={`${subFontSize} text-gray-400 uppercase tracking-wider`}>/100</span>
        </div>
      </div>
      <span
        className={`${compact ? 'text-sm' : 'text-base'} font-semibold`}
        style={{ color }}
      >
        {label}
      </span>
      <span className={`${compact ? 'text-xs' : 'text-sm'} text-gray-400 text-center max-w-[200px]`}>
        {action}
      </span>
    </div>
  );
}
